"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var data_service_1 = __importDefault(require("../../services/data.service"));
var web_view_service_1 = __importDefault(require("../../services/web-view.service"));
var comic_episode_list_1 = __importDefault(require("./comic-episode-list"));
var meta_1 = __importDefault(require("../shared/meta"));
var sharer_1 = __importDefault(require("../shared/sharer"));
var loading_1 = __importDefault(require("../shared/loading"));
var lang_service_1 = __importDefault(require("../../services/lang.service"));
var Comic = (function (_super) {
    __extends(Comic, _super);
    function Comic() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            comic: undefined,
        };
        _this.goToComicList = function () {
            _this.props.history.push("/comics/");
        };
        _this.goToEpisode = function (episode) {
            return _this.props.history.push("/".concat(_this.state.comic.slug, "/episodes/").concat(episode.slug, "/1/").concat(_this.props.location.search));
        };
        return _this;
    }
    Comic.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var comicSlug, comic;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (web_view_service_1.default.isWebView()) {
                            web_view_service_1.default.sendEvent({ name: 'reachedComic' });
                            window.addEventListener('backButtonPressed', this.goToComicList);
                        }
                        comicSlug = this.props.match.params.comicSlug;
                        return [4, data_service_1.default.getComicBySlug(comicSlug, true)];
                    case 1:
                        comic = _a.sent();
                        if (!comic) {
                            this.props.history.push('/404');
                        }
                        else {
                            this.setState({
                                comic: comic
                            });
                        }
                        return [2];
                }
            });
        });
    };
    Comic.prototype.componentWillUnmount = function () {
        if (web_view_service_1.default.isWebView()) {
            window.removeEventListener('backButtonPressed', this.goToComicList);
        }
    };
    Comic.prototype.render = function () {
        var _this = this;
        var comic = this.state.comic;
        if (!comic)
            return react_1.default.createElement(loading_1.default, null);
        var getLabel = lang_service_1.default.getLabel;
        return (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement(meta_1.default, { author: comic.author, title: getLabel(comic.title), description: getLabel(comic.shortDesc), keywords: getLabel(comic.tags), canonical: "/".concat(comic.slug, "/").concat(this.props.location.search), imagePath: comic.media.thumbnail }),
            react_1.default.createElement("div", { className: "comic" },
                (web_view_service_1.default.isWebView()) && (react_1.default.createElement("div", { className: "comic__actions" },
                    react_1.default.createElement("span", { onClick: this.goToComicList, className: "comic__back-btn" },
                        react_1.default.createElement("span", { className: "icon-arrow-back" })))),
                react_1.default.createElement("div", { className: "comic__backdrop", style: {
                        backgroundImage: "url(\"".concat(comic.media.poster, "\")"),
                        bottom: !comic.episodes.length || comic.isOneShot ? '0' : '120px',
                    } }),
                react_1.default.createElement("div", { className: "comic__main" },
                    react_1.default.createElement("div", { className: "comic__about" },
                        react_1.default.createElement("img", { className: "comic__about-img", src: comic.media.title, alt: getLabel(comic.title), title: getLabel(comic.title) }),
                        react_1.default.createElement("div", { className: "comic__about-text" },
                            react_1.default.createElement("div", { className: "comic__about-extras" },
                                react_1.default.createElement("span", null, comic.pubDate.slice(0, 4)),
                                react_1.default.createElement("span", { className: "comic__about-rating" }, comic.rating),
                                react_1.default.createElement("span", { className: "comic__about-langs" },
                                    react_1.default.createElement("span", { className: "icon icon-language" }),
                                    comic.supportedLangs.join(',').toUpperCase()),
                                react_1.default.createElement("span", null,
                                    getLabel('by'),
                                    ": ",
                                    react_1.default.createElement("strong", null, comic.author))),
                            react_1.default.createElement("p", { className: "comic__about-summary" }, getLabel(comic.about)),
                            react_1.default.createElement("div", { className: "comic__about-actions-container" },
                                !comic.episodes.length ? null :
                                    react_1.default.createElement("button", { className: "comic__about-btn", onClick: function () { return _this.goToEpisode(comic.episodes[0]); } },
                                        react_1.default.createElement("span", { className: "icon icon-play" }),
                                        getLabel((comic.isOneShot ? 'readOne' : 'readFirst'))),
                                react_1.default.createElement("div", { className: "comic__about-like" },
                                    react_1.default.createElement(sharer_1.default, { href: "/".concat(comic.slug, "/") })))))),
                !comic.isOneShot && react_1.default.createElement(comic_episode_list_1.default, { episodes: comic.episodes, onEpisodeClick: this.goToEpisode }))));
    };
    return Comic;
}(react_1.Component));
exports.default = Comic;
